import { bool } from "prop-types";
import { useMemo } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { getProfitColor } from "@utils";
import { useEstimateStructure } from "@tools";
import { TotalContainer } from "../components";
import { useTheme } from "@material-ui/core/styles";

export const TotalProfitability = observer(( containerProps ) => {
  
  const theme = useTheme();
  const { t } = useTranslation();
  const structure = useEstimateStructure();
  
  const { totalCompanyProfitability } = structure;
  
  const notApplicable = useMemo(() => (
    totalCompanyProfitability === null
  ), [totalCompanyProfitability]);
  
  const color = useMemo(() => (
    getProfitColor(totalCompanyProfitability, theme)
  ), [totalCompanyProfitability, theme]);
  
  const handleProfitabilityChange = (profitability) => {
    structure.setTotalCompanyProfitability(profitability);
  };
  
  return (
    <TotalContainer
      totalName="profitability"
      min={notApplicable ? t("common.na") : totalCompanyProfitability}
      symbolEnd={notApplicable ? undefined : "%"}
      style={{color}}
      onValueChange={handleProfitabilityChange}
      editable
      showDecimals
      allowNegative
      maxValue={99.99}
      {...containerProps}
    />
  );
})

TotalProfitability.propTypes = {
  compact: bool,
  showDivider: bool,
}